import {useState, useEffect, useRef} from 'react'
import { Link } from 'react-router-dom'
import axios from 'axios';
import AdminTitle from '../AdminTitle'

type Applicant = {
  id: number;
  name: string;
  japanese_level: string;
  nationality: string;
  education: string;
  created_at: string;
}[] | null

export default function AppplicantIndex() {
  // APIから取得した情報の状態管理
  const [applicants, setApplicants] = useState<Applicant>(null)
  // リロードさせるかどうかの状態管理
  const [needReload, setNeedReload] = useState(false)
  // ページネーション表示用の状態管理
  const [nowPage, setNowPage] = useState<number>(1)
  const [allPage, setAllPage] = useState<number>(1)
  const [pageList, setPageList] = useState<number[]>([])
  // 検索するパラメータの状態管理
  const [searchName, setSearchName] = useState<string | null>(null)
  const [searchJapaneseLevel, setSearchJapaneseLevel] = useState<string | null>(null)
  const [searchEducation, setSearchEducation] = useState<string | null>(null)
  // 検索フォームの入力を更新する
  const searchNameRef = useRef<HTMLInputElement | null>(null);
  const searchJapaneseLevelRef = useRef<HTMLSelectElement | null>(null);
  const searchEducationRef = useRef<HTMLSelectElement | null>(null);

  // APIから応募者一覧を取得して表示
  useEffect(() => {
    axios.get(`/api/v1/applicants`)
    .then(res => {
      setApplicants(JSON.parse(res.data.data))
      if (searchNameRef.current) {searchNameRef.current.value = ''}
      if (searchJapaneseLevelRef.current) {searchJapaneseLevelRef.current.value = ''};
      if (searchEducationRef.current) {searchEducationRef.current.value = ''};
      setSearchName(null);
      setSearchJapaneseLevel(null);
      setSearchEducation(null);
      const page : number = Math.ceil(res.data.count / 10)
      setAllPage(page)
      const pageArray : number[] = []
      for (let i = 1; i <= page; i++) {
        pageArray.push(i)
      }
      setPageList(pageArray)
    })
    .catch(error => {
      console.log(error)
    });
  }, [needReload]);

  // 検索した際の応募者一覧の取得
  const fetchApplicants = () => {
    axios.get('/api/v1/applicants/search', { params: { keyword: searchName, japanese_level: searchJapaneseLevel, education: searchEducation } })
    .then(res => {
      setApplicants(JSON.parse(res.data.data));
      const page : number = Math.ceil(res.data.count / 10);
      setAllPage(page);
      setNowPage(1);
      const pageArray : number[] = []
      for (let i = 1; i <= page; i++) {
        pageArray.push(i)
      }
      setPageList(pageArray)
    })
    .catch(error => {
      console.log(error);
      alert('何らかのエラーが発生しました。もう一度お試しください。')
    });
  };

  return (
    <>
      <AdminTitle title={'応募者一覧'} />
      <div className='admin-bg__color'>
        <div className='breadcrumb'><ul><li>応募者一覧</li></ul></div>
        <div className='admin-list__card'>
          <div className='admin-list__card__header'>
            <div className='admin-list__card__header--form'>
              <input ref={searchNameRef} type='text' className='admin-list__card__header--form-main' placeholder='応募者名を入力' onChange={(e) => setSearchName(e.target.value)} />
              <select ref={searchJapaneseLevelRef} className='admin-list__card__header--form-main select' onChange={(e) => setSearchJapaneseLevel(e.target.value === '' ? null : e.target.value)}>
                <option value=''>日本語レベルを選択</option>
                <option value='N1'>ネイティブレベル（N1相当）</option>
                <option value='N2'>ビジネス会話レベル（N2相当）</option>
                <option value='N3'>日常会話レベル（N3相当）</option>
                <option value='N4'>簡単な会話ができるレベル（N4相当）</option>
                <option value='N5'>自己紹介・挨拶レベル（N5相当）</option>
              </select>
              <select ref={searchEducationRef} className='admin-list__card__header--form-main select' onChange={(e) => setSearchEducation(e.target.value === '' ? null : e.target.value)}>
                <option value=''>最終学歴を選択</option>
                <option value='high_school'>高校</option>
                <option value='vocational_school'>専門学校</option>
                <option value='junior_college'>短大</option>
                <option value='college'>大学</option>
                <option value='graduate_school'>大学院</option>
                <option value='other'>その他</option>
              </select>
            </div>
            <div className='admin-list__card__header--btn'>
              <div className='admin-list__card__header--btn-search' onClick={() => fetchApplicants()}>
                <i className="material-icons">search</i>
                <div>検索</div>
              </div>
              <div className='admin-list__card__header--btn-reset' onClick={() => setNeedReload(!needReload)}>
                <div>リセット</div>
              </div>
            </div>
          </div>

          <div className='admin-list__card__body border-top'>
            <table className="table table-striped">
              <thead>
                <tr>
                  <th className='head-text ps-4'>名前</th>
                  <th className='head-text'>日本語レベル</th>
                  <th className='head-text'>国籍</th>
                  <th className='head-text'>最終学歴</th>
                  <th className='head-text'>登録日</th>
                  <th className='head-text'></th>
                </tr>
              </thead>

              <tbody>
              {
                applicants &&
                applicants.slice((nowPage - 1) * 10, nowPage * 10).map(applicant =>
                  <tr key={applicant.id}>
                    <td className='py-4 align-middle ps-4'>{applicant.name}</td>
                    <td className='py-4 align-middle'>{applicant.japanese_level}</td>
                    <td className='py-4 align-middle'>{applicant.nationality}</td>
                    <td className='py-4 align-middle'>{applicant.education}</td>
                    <td className='py-4 align-middle'>{applicant.created_at.slice(0,10)}</td>
                    <td className='py-2 align-middle text-end'>
                      <div className="d-flex justify-content-end pe-4">
                        <Link to={`/admins/applicants/${applicant.id}`} className='btn btn-edit'>
                          <span className='material-symbols-outlined'>file_open</span>
                          詳　細
                        </Link>
                      </div>
                    </td>
                  </tr>
                )
              }
              </tbody>
            </table>
          </div>

          {/* ページネーション */}
          <div className='admin-list__card__footer'>
            <div className='d-flex align-items-center justify-content-center'>
              {nowPage > 1 && (
                <span className='material-symbols-outlined arrow-back arrow-back__active me-2 p-2' onClick={() => setNowPage(nowPage - 1)}>
                  arrow_back
                </span>
              )}
              {nowPage == 1 && (
                <span className='material-symbols-outlined arrow-back arrow-back__inactive me-2 p-2'>
                  arrow_back
                </span>
              )}
              {nowPage > 3 && (
                <button key={1} className='btn btn-pagenation mx-1' onClick={() => setNowPage(1)} >{1}</button>
              )}
              {nowPage > 4 && (
                <button key={2} className='btn btn-pagenation mx-1' onClick={() => setNowPage(2)} >{2}</button>
              )}
              {nowPage > 5 && (
                <button key={3} className='btn btn-pagenation mx-1' onClick={() => setNowPage(3)} >{3}</button>
              )}
              {nowPage > 5 && (
                <span className='mx-2'>...</span>
              )}
              {pageList
                .filter(page => page >= Math.max(1, nowPage - 2) && page <= Math.min(allPage, nowPage + 2))
                .map(page => (
                  <button
                    key={page}
                    className={`btn btn-pagenation mx-1 ${page === nowPage ? 'active' : ''}`}
                    onClick={() => setNowPage(page)}
                  >
                    {page}
                  </button>
                ))
              }
              {allPage - nowPage > 5 && (
                <span className='mx-2'>...</span>
              )}
              {allPage - nowPage > 4 && (
                <button key={allPage - 2} className='btn btn-pagenation mx-1' onClick={() => setNowPage(allPage - 2)} >{allPage - 2}</button>
              )}
              {allPage - nowPage > 3 && (
                <button key={allPage - 1} className='btn btn-pagenation mx-1' onClick={() => setNowPage(allPage - 1)} >{allPage - 1}</button>
              )}
              {allPage - nowPage > 2 && (
                <button key={allPage } className='btn btn-pagenation mx-1' onClick={() => setNowPage(allPage )} >{allPage }</button>
              )}
              {nowPage < allPage && (
                <span className='material-symbols-outlined arrow-next arrow-next__active' onClick={() => setNowPage(nowPage + 1)}>
                  arrow_forward
                </span>
              )}
              {nowPage == allPage && (
                <span className='material-symbols-outlined arrow-next arrow-next__inactive'>
                  arrow_forward
                </span>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  )
}
